import { render } from "./otp2.vue?vue&type=template&id=4fb56f15&scoped=true"
import script from "./otp2.vue?vue&type=script&lang=js"
export * from "./otp2.vue?vue&type=script&lang=js"

import "./otp2.vue?vue&type=style&index=0&id=4fb56f15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb56f15"]])

export default __exports__